"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsContainer = exports.Tab = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2;
var TabsContainer = exports.TabsContainer = _styledComponents["default"].section(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  height: 30px;\n"])));
var Tab = exports.Tab = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  text-transform: capitalize;\n  color: ", ";\n  margin-right: 15px;\n  padding-bottom: 4px;\n  border-bottom: ", ";\n  cursor: pointer;\n\n  ", "\n"])), function (props) {
  return props.isActive ? '#fff' : '#8D91AF';
}, function (props) {
  return props.isActive ? '2px solid #fff' : 'none';
}, function (_ref) {
  var theme = _ref.theme,
    isActive = _ref.isActive;
  return theme === 'light' && "\n      color: #33373D;\n      font-weight: ".concat(isActive ? '600' : 'normal', ";\n      border-bottom: ").concat(isActive ? '2px solid #33373D' : 'none', ";\n  ");
});